import { render } from "./cpt-richtxt.vue?vue&type=template&id=cfb649f4"
import script from "./cpt-richtxt.vue?vue&type=script&lang=js"
export * from "./cpt-richtxt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__